import { useCallback, useEffect, useState } from 'react';
import { intakeCrmApi, type LeadDetail } from '@/features/intake/api/intakeCrmApi';

export const useLeadInsights = (clientId: string) => {
  const [lead, setLead] = useState<LeadDetail | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchLeadInsights = useCallback(async () => {
    if (!clientId) {
      setLead(null);
      return;
    }

    try {
      setLoading(true);
      setError(null);
      const detail = await intakeCrmApi.getLeadDetail(clientId);
      setLead(detail);
    } catch (err) {
      console.warn('[useLeadInsights] Failed to load lead insights:', err);
      setLead(null);
      setError(err instanceof Error ? err.message : 'Failed to load AI lead insights');
    } finally {
      setLoading(false);
    }
  }, [clientId]);

  useEffect(() => {
    void fetchLeadInsights();
  }, [fetchLeadInsights]);

  return {
    lead,
    loading,
    error,
    fetchLeadInsights,
  };
};
